import type { ErrorType } from '../../shared/lib/axios/client'
import type {
  ChatThreadDto,
  PaginatedVerificationDto,
  ResolveChatThreadDto,
  SaveAnswerDto,
  UpdatePublicVerificationDto,
  UserClientVerificationDto,
  ValidationResult,
  VerificationControllerExportVerificationsParams,
  VerificationControllerFindAllParams,
  VerificationDto,
} from '.././types'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Detelio API specification
 * openAPI specification for Detelio API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'

import { axiosClient } from '../../shared/lib/axios/client'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

export const verificationControllerFindById = (
  id: string,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<VerificationDto>(
    { url: `https://stage-api.detelio.ai/verification/${id}`, method: 'GET', signal },
    options,
  )
}

export const getVerificationControllerFindByIdQueryKey = (id?: string) => {
  return [`https://stage-api.detelio.ai/verification/${id}`] as const
}

export const getVerificationControllerFindByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof verificationControllerFindById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verificationControllerFindById>>, TError, TData>
    >
    request?: SecondParameter<typeof axiosClient>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getVerificationControllerFindByIdQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof verificationControllerFindById>>> = ({ signal }) =>
    verificationControllerFindById(id, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof verificationControllerFindById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VerificationControllerFindByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof verificationControllerFindById>>
>
export type VerificationControllerFindByIdQueryError = ErrorType<unknown>

export function useVerificationControllerFindById<
  TData = Awaited<ReturnType<typeof verificationControllerFindById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verificationControllerFindById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof verificationControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof verificationControllerFindById>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVerificationControllerFindById<
  TData = Awaited<ReturnType<typeof verificationControllerFindById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verificationControllerFindById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof verificationControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof verificationControllerFindById>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVerificationControllerFindById<
  TData = Awaited<ReturnType<typeof verificationControllerFindById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verificationControllerFindById>>, TError, TData>
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVerificationControllerFindById<
  TData = Awaited<ReturnType<typeof verificationControllerFindById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verificationControllerFindById>>, TError, TData>
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getVerificationControllerFindByIdQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const verificationControllerFindByCaseId = (
  caseId: string,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<VerificationDto>(
    { url: `https://stage-api.detelio.ai/verification/by-case/${caseId}`, method: 'GET', signal },
    options,
  )
}

export const getVerificationControllerFindByCaseIdQueryKey = (caseId?: string) => {
  return [`https://stage-api.detelio.ai/verification/by-case/${caseId}`] as const
}

export const getVerificationControllerFindByCaseIdQueryOptions = <
  TData = Awaited<ReturnType<typeof verificationControllerFindByCaseId>>,
  TError = ErrorType<unknown>,
>(
  caseId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verificationControllerFindByCaseId>>, TError, TData>
    >
    request?: SecondParameter<typeof axiosClient>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getVerificationControllerFindByCaseIdQueryKey(caseId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof verificationControllerFindByCaseId>>> = ({
    signal,
  }) => verificationControllerFindByCaseId(caseId, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!caseId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof verificationControllerFindByCaseId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VerificationControllerFindByCaseIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof verificationControllerFindByCaseId>>
>
export type VerificationControllerFindByCaseIdQueryError = ErrorType<unknown>

export function useVerificationControllerFindByCaseId<
  TData = Awaited<ReturnType<typeof verificationControllerFindByCaseId>>,
  TError = ErrorType<unknown>,
>(
  caseId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verificationControllerFindByCaseId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof verificationControllerFindByCaseId>>,
          TError,
          Awaited<ReturnType<typeof verificationControllerFindByCaseId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVerificationControllerFindByCaseId<
  TData = Awaited<ReturnType<typeof verificationControllerFindByCaseId>>,
  TError = ErrorType<unknown>,
>(
  caseId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verificationControllerFindByCaseId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof verificationControllerFindByCaseId>>,
          TError,
          Awaited<ReturnType<typeof verificationControllerFindByCaseId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVerificationControllerFindByCaseId<
  TData = Awaited<ReturnType<typeof verificationControllerFindByCaseId>>,
  TError = ErrorType<unknown>,
>(
  caseId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verificationControllerFindByCaseId>>, TError, TData>
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVerificationControllerFindByCaseId<
  TData = Awaited<ReturnType<typeof verificationControllerFindByCaseId>>,
  TError = ErrorType<unknown>,
>(
  caseId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verificationControllerFindByCaseId>>, TError, TData>
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getVerificationControllerFindByCaseIdQueryOptions(caseId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const verificationControllerFindAll = (
  params?: VerificationControllerFindAllParams,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<PaginatedVerificationDto>(
    { url: `https://stage-api.detelio.ai/verification`, method: 'GET', params, signal },
    options,
  )
}

export const getVerificationControllerFindAllQueryKey = (params?: VerificationControllerFindAllParams) => {
  return [`https://stage-api.detelio.ai/verification`, ...(params ? [params] : [])] as const
}

export const getVerificationControllerFindAllQueryOptions = <
  TData = Awaited<ReturnType<typeof verificationControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params?: VerificationControllerFindAllParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationControllerFindAll>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getVerificationControllerFindAllQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof verificationControllerFindAll>>> = ({ signal }) =>
    verificationControllerFindAll(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof verificationControllerFindAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VerificationControllerFindAllQueryResult = NonNullable<
  Awaited<ReturnType<typeof verificationControllerFindAll>>
>
export type VerificationControllerFindAllQueryError = ErrorType<unknown>

export function useVerificationControllerFindAll<
  TData = Awaited<ReturnType<typeof verificationControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | VerificationControllerFindAllParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verificationControllerFindAll>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof verificationControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof verificationControllerFindAll>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVerificationControllerFindAll<
  TData = Awaited<ReturnType<typeof verificationControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params?: VerificationControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verificationControllerFindAll>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof verificationControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof verificationControllerFindAll>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVerificationControllerFindAll<
  TData = Awaited<ReturnType<typeof verificationControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params?: VerificationControllerFindAllParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationControllerFindAll>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVerificationControllerFindAll<
  TData = Awaited<ReturnType<typeof verificationControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params?: VerificationControllerFindAllParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationControllerFindAll>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getVerificationControllerFindAllQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const verificationControllerExportVerifications = (
  format: string,
  params?: VerificationControllerExportVerificationsParams,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<void>(
    { url: `https://stage-api.detelio.ai/verification/export/${format}`, method: 'GET', params, signal },
    options,
  )
}

export const getVerificationControllerExportVerificationsQueryKey = (
  format?: string,
  params?: VerificationControllerExportVerificationsParams,
) => {
  return [`https://stage-api.detelio.ai/verification/export/${format}`, ...(params ? [params] : [])] as const
}

export const getVerificationControllerExportVerificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof verificationControllerExportVerifications>>,
  TError = ErrorType<unknown>,
>(
  format: string,
  params?: VerificationControllerExportVerificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verificationControllerExportVerifications>>, TError, TData>
    >
    request?: SecondParameter<typeof axiosClient>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getVerificationControllerExportVerificationsQueryKey(format, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof verificationControllerExportVerifications>>> = ({
    signal,
  }) => verificationControllerExportVerifications(format, params, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!format, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof verificationControllerExportVerifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VerificationControllerExportVerificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof verificationControllerExportVerifications>>
>
export type VerificationControllerExportVerificationsQueryError = ErrorType<unknown>

export function useVerificationControllerExportVerifications<
  TData = Awaited<ReturnType<typeof verificationControllerExportVerifications>>,
  TError = ErrorType<unknown>,
>(
  format: string,
  params: undefined | VerificationControllerExportVerificationsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verificationControllerExportVerifications>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof verificationControllerExportVerifications>>,
          TError,
          Awaited<ReturnType<typeof verificationControllerExportVerifications>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVerificationControllerExportVerifications<
  TData = Awaited<ReturnType<typeof verificationControllerExportVerifications>>,
  TError = ErrorType<unknown>,
>(
  format: string,
  params?: VerificationControllerExportVerificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verificationControllerExportVerifications>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof verificationControllerExportVerifications>>,
          TError,
          Awaited<ReturnType<typeof verificationControllerExportVerifications>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVerificationControllerExportVerifications<
  TData = Awaited<ReturnType<typeof verificationControllerExportVerifications>>,
  TError = ErrorType<unknown>,
>(
  format: string,
  params?: VerificationControllerExportVerificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verificationControllerExportVerifications>>, TError, TData>
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVerificationControllerExportVerifications<
  TData = Awaited<ReturnType<typeof verificationControllerExportVerifications>>,
  TError = ErrorType<unknown>,
>(
  format: string,
  params?: VerificationControllerExportVerificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verificationControllerExportVerifications>>, TError, TData>
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getVerificationControllerExportVerificationsQueryOptions(format, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const verificationControllerFindVerificatonsByToken = (
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<UserClientVerificationDto>(
    { url: `https://stage-api.detelio.ai/verification/public/for-user-client`, method: 'GET', signal },
    options,
  )
}

export const getVerificationControllerFindVerificatonsByTokenQueryKey = () => {
  return [`https://stage-api.detelio.ai/verification/public/for-user-client`] as const
}

export const getVerificationControllerFindVerificatonsByTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof verificationControllerFindVerificatonsByToken>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof verificationControllerFindVerificatonsByToken>>, TError, TData>
  >
  request?: SecondParameter<typeof axiosClient>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getVerificationControllerFindVerificatonsByTokenQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof verificationControllerFindVerificatonsByToken>>> = ({
    signal,
  }) => verificationControllerFindVerificatonsByToken(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof verificationControllerFindVerificatonsByToken>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VerificationControllerFindVerificatonsByTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof verificationControllerFindVerificatonsByToken>>
>
export type VerificationControllerFindVerificatonsByTokenQueryError = ErrorType<unknown>

export function useVerificationControllerFindVerificatonsByToken<
  TData = Awaited<ReturnType<typeof verificationControllerFindVerificatonsByToken>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof verificationControllerFindVerificatonsByToken>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof verificationControllerFindVerificatonsByToken>>,
          TError,
          Awaited<ReturnType<typeof verificationControllerFindVerificatonsByToken>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVerificationControllerFindVerificatonsByToken<
  TData = Awaited<ReturnType<typeof verificationControllerFindVerificatonsByToken>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof verificationControllerFindVerificatonsByToken>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof verificationControllerFindVerificatonsByToken>>,
          TError,
          Awaited<ReturnType<typeof verificationControllerFindVerificatonsByToken>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVerificationControllerFindVerificatonsByToken<
  TData = Awaited<ReturnType<typeof verificationControllerFindVerificatonsByToken>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof verificationControllerFindVerificatonsByToken>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVerificationControllerFindVerificatonsByToken<
  TData = Awaited<ReturnType<typeof verificationControllerFindVerificatonsByToken>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof verificationControllerFindVerificatonsByToken>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getVerificationControllerFindVerificatonsByTokenQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const verificationControllerUpdateSelectionByToken = (
  updatePublicVerificationDto: UpdatePublicVerificationDto,
  options?: SecondParameter<typeof axiosClient>,
) => {
  return axiosClient<VerificationDto>(
    {
      url: `https://stage-api.detelio.ai/verification/public/for-user-client`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updatePublicVerificationDto,
    },
    options,
  )
}

export const getVerificationControllerUpdateSelectionByTokenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verificationControllerUpdateSelectionByToken>>,
    TError,
    { data: UpdatePublicVerificationDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof verificationControllerUpdateSelectionByToken>>,
  TError,
  { data: UpdatePublicVerificationDto },
  TContext
> => {
  const mutationKey = ['verificationControllerUpdateSelectionByToken']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verificationControllerUpdateSelectionByToken>>,
    { data: UpdatePublicVerificationDto }
  > = (props) => {
    const { data } = props ?? {}

    return verificationControllerUpdateSelectionByToken(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type VerificationControllerUpdateSelectionByTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof verificationControllerUpdateSelectionByToken>>
>
export type VerificationControllerUpdateSelectionByTokenMutationBody = UpdatePublicVerificationDto
export type VerificationControllerUpdateSelectionByTokenMutationError = ErrorType<unknown>

export const useVerificationControllerUpdateSelectionByToken = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verificationControllerUpdateSelectionByToken>>,
      TError,
      { data: UpdatePublicVerificationDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof verificationControllerUpdateSelectionByToken>>,
  TError,
  { data: UpdatePublicVerificationDto },
  TContext
> => {
  const mutationOptions = getVerificationControllerUpdateSelectionByTokenMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const verificationControllerSaveAnswerByToken = (
  saveAnswerDto: SaveAnswerDto,
  options?: SecondParameter<typeof axiosClient>,
) => {
  return axiosClient<void>(
    {
      url: `https://stage-api.detelio.ai/verification/public/for-user-client/answer`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: saveAnswerDto,
    },
    options,
  )
}

export const getVerificationControllerSaveAnswerByTokenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verificationControllerSaveAnswerByToken>>,
    TError,
    { data: SaveAnswerDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof verificationControllerSaveAnswerByToken>>,
  TError,
  { data: SaveAnswerDto },
  TContext
> => {
  const mutationKey = ['verificationControllerSaveAnswerByToken']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verificationControllerSaveAnswerByToken>>,
    { data: SaveAnswerDto }
  > = (props) => {
    const { data } = props ?? {}

    return verificationControllerSaveAnswerByToken(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type VerificationControllerSaveAnswerByTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof verificationControllerSaveAnswerByToken>>
>
export type VerificationControllerSaveAnswerByTokenMutationBody = SaveAnswerDto
export type VerificationControllerSaveAnswerByTokenMutationError = ErrorType<unknown>

export const useVerificationControllerSaveAnswerByToken = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verificationControllerSaveAnswerByToken>>,
      TError,
      { data: SaveAnswerDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof verificationControllerSaveAnswerByToken>>,
  TError,
  { data: SaveAnswerDto },
  TContext
> => {
  const mutationOptions = getVerificationControllerSaveAnswerByTokenMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const verificationControllerResolveChatThread = (
  resolveChatThreadDto: ResolveChatThreadDto,
  options?: SecondParameter<typeof axiosClient>,
) => {
  return axiosClient<ChatThreadDto>(
    {
      url: `https://stage-api.detelio.ai/verification/public/for-user-client/chat-thread`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: resolveChatThreadDto,
    },
    options,
  )
}

export const getVerificationControllerResolveChatThreadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verificationControllerResolveChatThread>>,
    TError,
    { data: ResolveChatThreadDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof verificationControllerResolveChatThread>>,
  TError,
  { data: ResolveChatThreadDto },
  TContext
> => {
  const mutationKey = ['verificationControllerResolveChatThread']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verificationControllerResolveChatThread>>,
    { data: ResolveChatThreadDto }
  > = (props) => {
    const { data } = props ?? {}

    return verificationControllerResolveChatThread(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type VerificationControllerResolveChatThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof verificationControllerResolveChatThread>>
>
export type VerificationControllerResolveChatThreadMutationBody = ResolveChatThreadDto
export type VerificationControllerResolveChatThreadMutationError = ErrorType<unknown>

export const useVerificationControllerResolveChatThread = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verificationControllerResolveChatThread>>,
      TError,
      { data: ResolveChatThreadDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof verificationControllerResolveChatThread>>,
  TError,
  { data: ResolveChatThreadDto },
  TContext
> => {
  const mutationOptions = getVerificationControllerResolveChatThreadMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const verificationControllerResetChatThread = (
  resolveChatThreadDto: ResolveChatThreadDto,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<ChatThreadDto>(
    {
      url: `https://stage-api.detelio.ai/verification/public/for-user-client/chat-thread/reset`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: resolveChatThreadDto,
      signal,
    },
    options,
  )
}

export const getVerificationControllerResetChatThreadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verificationControllerResetChatThread>>,
    TError,
    { data: ResolveChatThreadDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof verificationControllerResetChatThread>>,
  TError,
  { data: ResolveChatThreadDto },
  TContext
> => {
  const mutationKey = ['verificationControllerResetChatThread']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verificationControllerResetChatThread>>,
    { data: ResolveChatThreadDto }
  > = (props) => {
    const { data } = props ?? {}

    return verificationControllerResetChatThread(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type VerificationControllerResetChatThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof verificationControllerResetChatThread>>
>
export type VerificationControllerResetChatThreadMutationBody = ResolveChatThreadDto
export type VerificationControllerResetChatThreadMutationError = ErrorType<unknown>

export const useVerificationControllerResetChatThread = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verificationControllerResetChatThread>>,
      TError,
      { data: ResolveChatThreadDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof verificationControllerResetChatThread>>,
  TError,
  { data: ResolveChatThreadDto },
  TContext
> => {
  const mutationOptions = getVerificationControllerResetChatThreadMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const verificationControllerSubmitVerification = (
  verificationId: string,
  options?: SecondParameter<typeof axiosClient>,
) => {
  return axiosClient<ValidationResult>(
    {
      url: `https://stage-api.detelio.ai/verification/public/for-user-client/submit/${verificationId}`,
      method: 'PATCH',
    },
    options,
  )
}

export const getVerificationControllerSubmitVerificationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verificationControllerSubmitVerification>>,
    TError,
    { verificationId: string },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof verificationControllerSubmitVerification>>,
  TError,
  { verificationId: string },
  TContext
> => {
  const mutationKey = ['verificationControllerSubmitVerification']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verificationControllerSubmitVerification>>,
    { verificationId: string }
  > = (props) => {
    const { verificationId } = props ?? {}

    return verificationControllerSubmitVerification(verificationId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type VerificationControllerSubmitVerificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof verificationControllerSubmitVerification>>
>

export type VerificationControllerSubmitVerificationMutationError = ErrorType<unknown>

export const useVerificationControllerSubmitVerification = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verificationControllerSubmitVerification>>,
      TError,
      { verificationId: string },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof verificationControllerSubmitVerification>>,
  TError,
  { verificationId: string },
  TContext
> => {
  const mutationOptions = getVerificationControllerSubmitVerificationMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
